import { cn } from "../cn";

export function Avatar({
  initials,
  size = 32,
  className,
  tone = "ink",
}: {
  initials: string;
  size?: number;
  className?: string;
  tone?: "ink" | "brand";
}) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full font-medium text-white",
        tone === "ink" ? "bg-ink" : "bg-brand",
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
      aria-hidden
    >
      {initials}
    </span>
  );
}
